import { PORTAL_CREATE, PORTAL_DELETE, PORTAL_LIST, PORTAL_VIEW, USERS_DROPDOWN, PORTAL_EDIT, ADD_RESOURCE_PORTAL, ADD_USER_PORTAL, REMOVE_USER_PORTAL, GLOSSARY_DROPDOWN, REMOVE_GLOSSARY_PORTAL } from "./types";

export const portalList = (data, onSuccess, onError) => {
    return {
        type: PORTAL_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const portalView = (id, onSuccess, onError) => {
    return {
        type: PORTAL_VIEW,
        id,
        onSuccess,
        onError,
    };
};

export const usersDropDown = (data, onSuccess, onError) => {
    return {
        type: USERS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const portalDelete = (data, onSuccess, onError) => {
    return {
        type: PORTAL_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const portalCreate = (data, onSuccess, onError) => {
    return {
        type: PORTAL_CREATE,
        data,
        onSuccess,
        onError,
    };
};

export const portalEdit = (data, onSuccess, onError) => {
    return {
        type: PORTAL_EDIT,
        data,
        onSuccess,
        onError,
    };
};

export const glossaryDropDown = (data, onSuccess, onError) => {
    return {
        type: GLOSSARY_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const addResourcePortal = (data, onSuccess, onError) => {
    return {
        type: ADD_RESOURCE_PORTAL,
        data,
        onSuccess,
        onError,
    };
};

export const addUserPortal = (data, onSuccess, onError) => {
    return {
        type: ADD_USER_PORTAL,
        data,
        onSuccess,
        onError,
    };
};

export const removeUserPortal = (data, onSuccess, onError) => {
    return {
        type: REMOVE_USER_PORTAL,
        data,
        onSuccess,
        onError,
    };
};

export const removeGlossaryPortal = (data, onSuccess, onError) => {
    return {
        type: REMOVE_GLOSSARY_PORTAL,
        data,
        onSuccess,
        onError,
    };
};